import React from 'react'
import styled from '@emotion/styled';

const Wrapper = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 9999;
    top: 0px;
    left: 0px;
    background-color: ${({theme}) => theme.colors.lightBlackOpacity};
    border-radius: ${({theme}) => theme.borderRadius.default};
`;

const Overlay = props => <Wrapper />

export default Overlay;